var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHideQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1735_19754)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0007 5.83333C12.3007 5.83333 14.1673 7.7 14.1673 10C14.1673 10.5417 14.059 11.05 13.8673 11.525L16.3007 13.9583C17.559 12.9083 18.5507 11.55 19.159 10C17.7173 6.34167 14.159 3.75 9.99232 3.75C8.82565 3.75 7.70898 3.95833 6.67565 4.33333L8.47565 6.13333C8.95065 5.94167 9.45898 5.83333 10.0007 5.83333ZM1.66732 3.55833L3.95065 5.84167C2.56732 6.91667 1.48398 8.35 0.833984 10C2.27565 13.6583 5.83398 16.25 10.0007 16.25C11.2923 16.25 12.5257 16 13.6507 15.55L14.0007 15.9L16.4423 18.3333L17.5007 17.275L2.72565 2.5L1.66732 3.55833ZM6.27565 8.16667L7.56732 9.45833C7.52565 9.63333 7.50065 9.81667 7.50065 10C7.50065 11.3833 8.61732 12.5 10.0007 12.5C10.184 12.5 10.3673 12.475 10.5423 12.4333L11.834 13.725C11.2757 14 10.659 14.1667 10.0007 14.1667C7.70065 14.1667 5.83398 12.3 5.83398 10C5.83398 9.34167 6.00065 8.725 6.27565 8.16667ZM9.86732 7.51667L12.4923 10.1417L12.509 10.0083C12.509 8.625 11.3923 7.50833 10.009 7.50833L9.86732 7.51667Z",
    fill: "black",
    fillOpacity: 0.56
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1735_19754"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHideQuestion);
export default __webpack_public_path__ + "static/media/hideQuestion.88242e2da3677eb8b34d7123a75db4ac.svg";
export { ForwardRef as ReactComponent };